import React from "react";
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinkScroll,
  FooterLinkAnchor,
  HR,
  FooterLinksWrapper,
  FooterLinkTitle,
  FooterLinkItems,
  SocialMedia,
  SocialIconLink,
  SocialIcons,
  SocialLogo,
  SocialMediaWrap,
  WebsiteRights,
} from "./FooterElements";
import { animateScroll as scroll } from "react-scroll";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";

const toggleHome = () => {
  scroll.scrollToTop();
};
const Footer = () => {
  return (
    <FooterContainer id="Howitworks">
      <HR />
      <FooterWrap>
        <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLinkTitle>Company</FooterLinkTitle>
              {/* <FooterLink to="/about">About</FooterLink> */}
              <FooterLinkAnchor
                href="https://about-paythumb.notion.site/about-paythumb/Who-we-are-40fd6ea8c2244549984c9cd589422f78"
                target="_blank"
                rel="noreferrer"
              >
                About
              </FooterLinkAnchor>
              <FooterLinkAnchor
                href="https://communityinviter.com/apps/paythumbcommunity/paythumb-community"
                target="_blank"
                rel="noreferrer"
              >
                Slack Community
              </FooterLinkAnchor>
              {/*TODO: Add Paythumb terms and privacy links when ready*/}
              {/* <FooterLink to="#">Terms</FooterLink>
              <FooterLink to="#">Privacy Policy</FooterLink> */}
            </FooterLinkItems>

            <FooterLinkItems>
              <FooterLinkTitle>Product</FooterLinkTitle>
              <FooterLinkScroll
                to="Howitworks"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                How It Works
              </FooterLinkScroll>
              <FooterLinkAnchor
                href="https://drive.google.com/file/d/1lPwMt9Ab3Al9oxfVsOS60S1vSwgQBsDC/view"
                target="_blank"
                rel="noopener noreferrer"
              >
                Pricing
              </FooterLinkAnchor>
              <FooterLinkAnchor
                href="https://about-paythumb.notion.site/FAQs-4696e97c35c34490bb1806d1b362fd30"
                target="_blank"
                rel="noreferrer"
              >
                FAQs
              </FooterLinkAnchor>
            </FooterLinkItems>
          </FooterLinksWrapper>

          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLinkTitle>Resources</FooterLinkTitle>
              <FooterLinkAnchor
                href="https://www.health.go.ug/covid/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Covid-19
              </FooterLinkAnchor>
              <FooterLinkAnchor
                href="https://docs.google.com/forms/d/e/1FAIpQLScejI3gYZio4Nm_lgPxPdoUMUg9SzHYKolo3Doft5O8s7UnDA/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                User Survey
              </FooterLinkAnchor>
              <FooterLinkAnchor
                href="https://docs.google.com/forms/d/e/1FAIpQLSdPqJXJLZ-Ih8bw5cstrLTU36pTTGlfaDkZg3Z9Dks2Q6_ARg/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                Business Survey
              </FooterLinkAnchor>
            </FooterLinkItems>
          </FooterLinksWrapper>
        </FooterLinksContainer>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to="/" onClick={toggleHome}>
              Paythumb
            </SocialLogo>
            <WebsiteRights>
              &copy; {new Date().getFullYear()} Paythumb
            </WebsiteRights>
            <SocialIcons>
              <SocialIconLink
                href="https://web.facebook.com/paythumbpayments"
                target="blank"
                aria-label="Facebook"
              >
                <FaFacebook />
              </SocialIconLink>

              <SocialIconLink
                href="https://www.instagram.com/paythumbpayments/"
                target="blank"
                aria-label="Facebook"
              >
                <FaInstagram />
              </SocialIconLink>
              <SocialIconLink
                href="https://www.linkedin.com/company/paythumb"
                target="blank"
                aria-label="Linkedin"
              >
                <FaLinkedin />
              </SocialIconLink>
              {/* //TODO: Should Add social media links to these when we set them up */}
              {/* <SocialIconLink href ='/' target='blank'
                            aria-label='Instagram'>
                                <FaInstagram/>
                            </SocialIconLink>
                            <SocialIconLink href ='/' target='blank'
                            aria-label='Twitter'>
                                <FaTwitter/>
                            </SocialIconLink>
                            <SocialIconLink href ='/' target='blank'
                            aria-label='Youtube'>
                                <FaYoutube/>
                            </SocialIconLink> */}
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
